const formServicesData = {
    "i-90": {
        hero: {
            badge: "Form I-90",
            title: "Green Card Renewal & Replacement",
            subtitle: "Lost, expired, or damaged card? Get your new one fast — approval guaranteed"
        },
        price: "$99",
        savings: "Save $850 on average vs attorney",
        packageName: "Green Card Renewal/Replacement Package",
        forms: [
            "Form I-90, Application to Replace Permanent Resident Card",
            "Form G-1145, e-Notification of Application/Petition Acceptance",
            "Personalized instructions with a supporting document checklist",
            "Live support from citizenhup experts",
            "Guaranteed approval or your money back"
        ],
        color: "blue" 
    },

    "i-129f": {
        hero: {
            badge: "Form I-129F",
            title: "K-1 Fiancé Visa Petition",
            subtitle: "Bring your fiancé(e) to the U.S. and get married within 90 days"
        },
        price: "$149",
        savings: "Save $850 on average vs attorney",
        packageName: "K-1 Visa Petition Package",
        forms: [
            "Form I-129F, Petition for Alien Fiancé",
            "Form G-1145, e-Notification",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "pink"
    },

    "i-130": {
        hero: {
            badge: "Form I-130",
            title: "Petition for Alien Relative",
            subtitle: "Sponsor your spouse, child, parent, or sibling for a green card"
        },
        price: "$149",
        savings: "Save $850 on average vs attorney",
        packageName: "Immigrant Visa Petition Package",
        forms: [
            "Form I-130, Petition for Alien Relative",
            "Form I-130A Supplement (if spouse)",
            "Form G-1145, e-Notification",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "purple"
    },

    "i-131": {
        hero: {
            badge: "Form I-131",
            title: "Advance Parole Travel Document",
            subtitle: "Travel abroad while your green card or adjustment is pending"
        },
        price: "$99",
        savings: "Save $350 on average vs attorney",
        packageName: "Travel Document Application Package",
        forms: [
            "Form I-131, Application for Travel Document",
            "Form G-1145",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "indigo"
    },

    "i-485": {
        hero: {
            badge: "Form I-485",
            title: "Adjustment of Status (Green Card)",
            subtitle: "Complete family-based adjustment package — the biggest savings!"
        },
        price: "$279",
        savings: "Save $2,950 on average vs attorney",
        packageName: "Adjustment of Status Package",
        forms: [
            "Form I-485 (main form)",
            "Form I-130 & I-130A (as needed)",
            "Form G-1145",
            "Personalized instructions & checklist",
            "Live expert support",
            "30% discount on additional forms",
            "Guaranteed approval or money back"
        ],
        color: "emerald"
    },

    "i-751": {
        hero: {
            badge: "Form I-751",
            title: "Remove Conditions on Green Card",
            subtitle: "Convert your 2-year conditional card to permanent 10-year card"
        },
        price: "$139",
        savings: "Save $950 on average vs attorney",
        packageName: "Removal of Conditions Petition Package",
        forms: [
            "Form I-751, Petition to Remove Conditions",
            "Form G-1145",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "violet"
    },

    "i-765": {
        hero: {
            badge: "Form I-765",
            title: "Employment Authorization (EAD)",
            subtitle: "Get permission to work legally in the U.S."
        },
        price: "$79",
        savings: "Save $350 on average vs attorney",
        packageName: "Employment Authorization Package",
        forms: [
            "Form I-765, Application for Employment Authorization",
            "Form G-1145",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "cyan"
    },

    "i-821d": {
        hero: {
            badge: "Form I-821D",
            title: "DACA Renewal",
            subtitle: "Renew your DACA and work permit with confidence"
        },
        price: "$119",
        savings: "Save $850 on average vs attorney",
        packageName: "DACA Application Package",
        forms: [
            "Form I-821D (DACA)",
            "Form I-765 + Worksheet",
            "Form G-1145",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "teal"
    },

    "i-864": {
        hero: {
            badge: "Form I-864",
            title: "Affidavit of Support",
            subtitle: "Prove you can financially support your immigrant"
        },
        price: "$129",
        savings: "Save $950 on average vs attorney",
        packageName: "Affidavit of Support Package",
        forms: [
            "Form I-864",
            "Form I-864A (additional $25 each if needed)",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "amber"
    },

    "n-400": {
        hero: {
            badge: "Form N-400",
            title: "U.S. Citizenship Application",
            subtitle: "Become a U.S. citizen — the final step of your journey"
        },
        price: "$199",
        savings: "Save $950 on average vs attorney",
        packageName: "Naturalization Application Package",
        forms: [
            "Form N-400, Application for Naturalization",
            "Form G-1145",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "rose"
    },

    "n-565": {
        hero: {
            badge: "Form N-565",
            title: "Replace Citizenship Document",
            subtitle: "Lost or damaged Certificate of Citizenship or Naturalization?"
        },
        price: "$99",
        savings: "Save $550 on average vs attorney",
        packageName: "Citizenship Document Replacement Package",
        forms: [
            "Form N-565",
            "Form G-1145",
            "Personalized instructions & checklist",
            "Live expert support",
            "Guaranteed approval or money back"
        ],
        color: "slate"
    }
};

export default formServicesData;